import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", !this.menuTarget.classList.contains("hidden"))

    // Rotate chevron icon in the button
    const chevron = this.element.querySelector(".fa-chevron-down")
    if (chevron) {
      chevron.classList.toggle("rotate-180")
    }
  }

  // Closes on a click outside the menu or on Escape.
  hide(event) {
    if (event.type === "click" && this.element.contains(event.target)) return
    if (this.menuTarget.classList.contains("hidden")) return

    this.toggle()
    if (event.type === "keydown" && this.hasButtonTarget) this.buttonTarget.focus()
  }
}
